$w.onReady(() => {
	waitForLoading();
});

export function button6_onClick() {
	$w('#columnStrip5').show();
	waitForLoading();
}

function waitForLoading() {
	setTimeout(() => {
		$w('#columnStrip5').hide('FadeOut');
	}, 1500);
}
